import React from "react";
import * as Yup from 'yup';
import { Frazione, Comune, ClienteData } from "../../generated"
import { ComuniAutocomplete } from "../../comuni/components/comuniAutocomplete";
import { FrazioneSelector } from "../../comuni/components/FrazioneSelector";
import { Forms, Divider } from "../../common/components/CmForms";
const { Form, FormSwitch, FormText, ActionBar } = Forms<ClienteData>()

interface Props {
    customer: ClienteData;
    onSubmit: (customer: ClienteData) => void;
    onCancel: () => void;
}

export default class CustomerFormLight extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<ClienteData>>({
        cognomeProprietario: Yup
            .string()
            .required('Campo obbligatorio'),
        indirizzo: Yup
            .string()
            .required('Campo obbligatorio'),
        comune: Yup
            .object<Comune>()
            .required('Campo obbligatorio'),
        frazione: Yup
            .object<Frazione>()
            .required('Campo obbligatorio'),
    })
    render() {
        const { customer } = this.props;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={customer}
                validationSchema={CustomerFormLight.validationSchema}
            >
                {
                    ({ set, values, errors }) =>
                        <div className="pb-3">
                            <div className="row d-flex align-items-center">
                                <div className="col-12">
                                    <Divider caption="Dati identificativi" />
                                </div>
                                <div className="col-12 col-md-6 d-flex flex-wrap">
                                    <div className="me-5">
                                        <FormSwitch
                                            name="azienda"
                                            label="Azienda"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className={values.azienda ? "col-12" : "col-12 col-md-6"}>
                                    <FormText
                                        name="cognomeProprietario"
                                        label={values.azienda ? "Ragione Sociale" : "Cognome"}
                                        readOnly={values.dismessa}
                                    />
                                </div>
                                {!values.azienda && <div className="col-12 col-md-6">
                                    <FormText
                                        name="nomeProprietario"
                                        label="Nome"
                                        readOnly={values.dismessa}
                                    />
                                </div>}
                                <div className="col-12 col-md-6">
                                    <FormText
                                        name="responsabile"
                                        label="Responsabile (Inquilino)"
                                        readOnly={values.dismessa}
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        name="telefono"
                                        label="Telefono"
                                        readOnly={values.dismessa}
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        name="cell"
                                        label="Cellulare"
                                        readOnly={values.dismessa}
                                    />
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <ComuniAutocomplete
                                            label="Comune"
                                            onChange={comune => {
                                                set("comune", comune ?? undefined)
                                            }}
                                            value={values.comune}
                                            error={errors.comune}
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                    <div className="col-12">
                                        {values.comune && <FrazioneSelector
                                            label="Frazione"
                                            codFisComune={values.comune.codFisComune}
                                            onChange={frazione => set("frazione", frazione ?? undefined)}
                                            value={values.frazione ?? null}
                                            error={errors.frazione}
                                            readonly={values.dismessa}
                                        />}
                                    </div>
                                    <div className="col-12 col-md-10">
                                        <FormText
                                            name="indirizzo"
                                            label="Indirizzo"
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <FormText
                                            name="piano"
                                            label="Piano"
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                </div>
                            </div>
                            <ActionBar
                                onCancel={this.props.onCancel}
                            />
                        </div>}
            </Form>
        );
    }
}
